import UpdatesTable from './UpdatesTable'

export default UpdatesTable
